import ApiHelper from "../../helpers/ApiHelper";
import GeneralVariables from "../../utils/GeneralVariables";
import BaseService from "../BaseService";
import store from "../../../store";


class KitService extends BaseService {
    static url = "kits";
    static paths = "/storage/kits/";
    static apis = {
        that: this,
        getLatest: this.url + "/latestCarousel",
        getLatestSold: this.url + "/latestSold",
        create: { method: "post", path: "" },
        filter: { method: "get", path: this.url + "/filter" },
        getKitList: { method: "get", path: this.url + "/list" },
        duplicateKit: { method: "post", path: this.url + "/duplicate" },
        deleteKits: { method: "delete", path: this.url },
        calculateDisplayPrice:{method:'get', path: this.url + "/calculateDisplayPrice"},
        calculateNetToSeller:{method:'get', path: this.url + "/calculateNetToSeller"},
        filterBrands:{method:'get', path: this.url + "/filterBrands"},
        filterCategories:{method:'get', path: this.url + "/filterCategories"},
        filterSpecs:{method:'get', path: this.url + "/filterSpecs"},
        filterMaxPrice:{method:'get', path: this.url + "/filterMaxPrice"},
        filterMinPrice:{method:'get', path: this.url + "/filterMinPrice"},
        filterProducts:{method:'get', path: this.url + "/filterProducts"},
        filterKeywords:{method:'get', path: this.url + "/filterKeywords"},
        filterKitSources:{method:'get', path: this.url + "/filterKitSources"},
        matchRfps:{method:'get', path: this.url + '/matching-rfps'},
        fromImage:{method:'post', path: this.url + "/from-image"},
        expandDescription:{method:'get', path: this.url + "/expand-description"},
        creation_chat:{method:'post', path: this.url + "/creation_chat"},
        export: {method: 'get', path: this.url + "/export"},
        suggestAccessories: {method: 'get', path: this.url + "/suggest-accessories"},

        getPriceById: function(id) {
            return this.that.url + "/" + id + "/price";
        },
        getById: function(id) {
            return this.that.url + "/" + id + "/details";
        },
        addImage: function(id) {
            return this.that.url + "/" + id + "/images";
        },
        addFile: function(id) {
            return this.that.url + "/" + id + "/files";
        },
        similar: function(id) {
            return this.that.url + "/" + id + "/similar";
        },
        removeImage: function(id) {
            return this.that.url + "/" + id + "/images";
        },
        deepSearch: { method: "get", path: this.url + "/search" },
        views: function(id) {
            return this.that.url + "/" + id + "/views";
        },
        registerViewer: function(id) {
            return this.that.url + "/" + id + "/register-viewer";
        },
        editStatus: function(id) {
            return this.that.url + "/" + id + "/status";
        },
        getKitSources: function(){
            return "kit-sources";
        }
    };

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("kits");
    }

    suggestAccessories(title, accessories) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.suggestAccessories.path+"?title="+title+"&current_accessories="+accessories,
                    method: KitService.apis.suggestAccessories.method,
                    authorization: false,
                    showLoader: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async createFromChatStream(data) 
    {
        let url = GeneralVariables.BACKEND + 'api/v1.0/' + KitService.apis.creation_chat.path
                let token = store.getters.token
                return fetch(url, {
                        method: KitService.apis.creation_chat.method, // *GET, POST, PUT, DELETE, etc.
                        mode: "cors", // no-cors, *cors, same-origin
                        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: "same-origin", // include, *same-origin, omit
                        headers: {
                        "Content-Type": "application/json",
                        "Authorization":"Bearer "+ token
                        },
                        redirect: "follow", // manual, *follow, error
                        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        body: JSON.stringify(data), // body data type must match "Content-Type" header
                    }
                );
                
    }

    exportAllKits(data){
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.export.path,
                    method: KitService.apis.export.method,
                    authorization: true,
                    responseType: 'blob',
                    params: data,
                })
                .then((response) => {
                    const now = new Date();
                    const day = String(now.getDate()).padStart(2, '0');
                    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                    const year = now.getFullYear();
                    const fileName = `Topotrade_Items_${day}-${month}-${year}.xlsx`;
                    const url = URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                      'download',
                      fileName
                    )
                    document.body.appendChild(link)
                    link.click()
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getPriceKit(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getPriceById(id),
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getMatchingRFPs(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.matchRfps.path+'/'+id,
                    method: KitService.apis.matchRfps.method,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    expandDescription(id, title='', description='') {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.expandDescription.path+'/'+id+"?title="+title+"&description="+description,
                    method: KitService.apis.expandDescription.method,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getKitSources(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getKitSources(),
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    calculateDisplayPrice(kitId,currencyId,netToSeller, service_center_id=null)
    {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.calculateDisplayPrice.path+`?id=${kitId}&currency_id=${currencyId}&price=${netToSeller}${service_center_id?`&service_center_id=${service_center_id}`:''}`,
                    method: KitService.apis.calculateDisplayPrice.method,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    calculateNetToSeller(kitId,currencyId,price, service_center_id)
    {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.calculateNetToSeller.path+`?id=${kitId}&currency_id=${currencyId}&price=${price}${service_center_id?`&service_center_id=${service_center_id}`:''}`,
                    method: KitService.apis.calculateNetToSeller.method,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    

    views(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.views(id),
                    method: "POST",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    registerViewer(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.registerViewer(id),
                    method: "POST",
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    deleteKits(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.deleteKits.path,
                    method: KitService.apis.deleteKits.method,
                    data: { ids: ids },
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    duplicate(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.duplicateKit.path,
                    method: KitService.apis.duplicateKit.method,
                    data: { ids: ids },
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    similar(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.similar(id),
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getById(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getById(id),
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    getKitList(data, authorize = false) {
        var array = [];
        data.forEach(function(item) {
            array.push(item.kit);
        });
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getKitList.path,
                    method: KitService.apis.getKitList.method,
                    params: { ids: array },
                    authorization: authorize,
                    showLoader: true,
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getKitListByIds(array) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getKitList.path,
                    method: KitService.apis.getKitList.method,
                    params: { ids: array },
                    authorization: false,
                    showLoader: true,
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getLatest(data) {
        var that = this;
        var inUrlParams =
            data != undefined ? ApiHelper.buildInlineParams(data) : "";
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getLatest.concat(inUrlParams),
                    method: "GET",
                    authorization: false,
                    showLoader: false,
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    getLatestSold(data) {
        var that = this;
        var inUrlParams =
            data != undefined ? ApiHelper.buildInlineParams(data) : "";
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.getLatestSold.concat(inUrlParams),
                    method: "GET",
                    authorization: false,
                    showLoader: false,
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    deepSearch(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.deepSearch.path,
                    method: KitService.apis.deepSearch.method,
                    params: data,
                    authorization: false,
                    showLoader: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    createKit(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.create.path,
                    method: KitService.apis.create.method,
                    data: data,
                    showLoader: true,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }


    createKitFromImage(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.fromImage.path,
                    method: KitService.apis.fromImage.method,
                    data: data,
                    showLoader: false,
                    authorization: true,
                    signal: data.signal
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }


    async createKitFromImageStream(data) 
    {
        let url = GeneralVariables.BACKEND + 'api/v1.0/' + KitService.apis.fromImage.path
                let token = store.getters.token
                return fetch(url, {
                        method: KitService.apis.fromImage.method, // *GET, POST, PUT, DELETE, etc.
                        mode: "cors", // no-cors, *cors, same-origin
                        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: "same-origin", // include, *same-origin, omit
                        headers: {
                        "Content-Type": "application/json",
                        "Authorization":"Bearer "+ token
                        },
                        redirect: "follow", // manual, *follow, error
                        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        body: JSON.stringify(data), // body data type must match "Content-Type" header
                        signal: data.signal
                    }
                );
                
    }

    filter(data, authorize = false) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filter.path,
                    method: KitService.apis.filter.method,
                    authorization: authorize,
                    showLoader:false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterBrands(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterBrands.path,
                    method: KitService.apis.filterBrands.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterCategories(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterCategories.path,
                    method: KitService.apis.filterCategories.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterKeywords(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterKeywords.path,
                    method: KitService.apis.filterKeywords.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterKitSources(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterKitSources.path,
                    method: KitService.apis.filterKitSources.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterSpecs(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterSpecs.path,
                    method: KitService.apis.filterSpecs.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterMinPrice(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterMinPrice.path,
                    method: KitService.apis.filterMinPrice.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterMaxPrice(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterMaxPrice.path,
                    method: KitService.apis.filterMaxPrice.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterProducts(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.filterProducts.path,
                    method: KitService.apis.filterProducts.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    editStatus(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.editStatus(data.id),
                    method: "put",
                    authorization: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    addImage(file, kitId, message) {
        var that = this;
        let formData = new FormData();
        formData.append("file", file);
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.addImage(kitId),
                    showLoader: false,
                    formData: true,
                    method: "POST",
                    authorization: true,
                    data: formData,
                    message: message,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    addFile(file, kitId, message) {
        var that = this;
        let formData = new FormData();
        formData.append("file", file);
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitService.apis.addFile(kitId),
                    showLoader: false,
                    formData: true,
                    method: "POST",
                    authorization: true,
                    data: formData,
                    message: message,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }


}

export default KitService;